import { request }         from "./http";
import type { ReportSummary } from "./types";
import type { ReportInstance } from "../report-engine/types";

export type { ReportSummary };

/** List all reports (lightweight — no data payload) */
export const listReports = () =>
  request<ReportSummary[]>("/reports");

/** Get a full report instance by id */
export const getReport = (id: string) =>
  request<ReportInstance>(`/reports/${id}`);

/** Save (create or update) a report instance. Returns { ok, updatedAt }. */
export const saveReport = (instance: ReportInstance) =>
  request<{ ok: boolean; updatedAt: string }>("/reports", {
    method: "POST",
    body:   JSON.stringify(instance),
  });

/** Delete a report by id. Returns { ok }. */
export const deleteReport = (id: string) =>
  request<{ ok: boolean }>(`/reports/${id}`, { method: "DELETE" });

/** Check backend availability */
export const checkHealth = () =>
  request<{ ok: boolean; db: string }>("/health");
